import React from 'react';

import { TruncatedLink } from '@components/common/react-table/TruncatedLink';
import { TruncatedText } from '@components/common/react-table/TruncatedText';

import type { IHistoricalDocument } from '../constants';
import { suggestedDownloadFileName } from '@utils/miscellaneous/file.utils';

export const historicalDocumentsTableColumns = [
    {
        id: 'documentDescription',
        Header: 'common.document_description',
        accessor: 'documentDescription',
        Cell: ({ row }: { row: { original: IHistoricalDocument } }) => {
            const doc = row.original;
            const description = doc.documentDescription ?? '';

            if (!doc.documentUrl) {
                return <TruncatedText text={description} />;
            }

            return (
                <TruncatedLink
                    href={doc.documentUrl}
                    text={description}
                    download={suggestedDownloadFileName(description)}
                />
            );
        },
    },
    {
        id: 'uploadedBy',
        Header: 'historicalDocuments.table.uploadedBy',
        accessor: 'uploadedBy',
        isSortEnabled: false,
        Cell: ({ value }: { value: string }) => <TruncatedText text={value ?? ''} />,
    },
    {
        id: 'uploadedDate',
        Header: 'historicalDocuments.table.uploadedOn',
        accessor: 'uploadedDate',
        Cell: ({ value }: { value: string }) => <TruncatedText text={value ?? ''} />,
    },
    {
        id: 'status',
        Header: 'historicalDocuments.table.status',
        accessor: 'status',
        isSortEnabled: false,
        Cell: ({ value }: { value: string }) => <TruncatedText text={value ?? ''} />,
    },
];
